<template>
    <b-modal
        modal-class="modal-full action-modal"
        :visible="visible"
        @hidden="hideModal"
    >
        <template #modal-header>
            <div class="container">
                <h3 class="mb-0">Action #{{ clientActionId }}</h3>
            </div>
            <button @click="hideModal" type="button" aria-label="Close" class="close">×</button>
        </template>
        <action-item
            v-if="clientActionId !== null"
            :key="clientActionId"
            :client-action-id="clientActionId"
            :show-action-buttons="false"
            @close="hideModal"
        >
        </action-item>
        <template #modal-footer>
            <action-buttons
                @close="hideModal"
            >
            </action-buttons>
        </template>
    </b-modal>
</template>

<script>
import ModalMixin from '@/components/Modal/ModalMixin';
import ActionItem from '@/components/Action/Action';
import ActionButtons from '@/components/Action/ActionButtons';

export default {
  name: 'Action-Modal',
  components: {
    ActionItem,
    ActionButtons,
  },
  props: {
    clientActionId: {
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'actionModal',
      loading: false,
      visible: false,
    };
  },
  watch: {
    show: {
      handler(newValue) {
        this.visible = newValue;
      },
      immediate: true,
    },
  },
  methods: {
    hideModal() {
      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="scss">
    $modal-header-height: 61px;
    $modal-footer-height: 91px;
    $modal-body-padding: 35px;
    $tab-nav-height: 65px;
    $tab-nav-small-height: 65px;
    $tab-content-padding: 30px;
    $tab-sm-adjust: 60px;

    .action-modal {
        .action-buttons {
            .cancel {
                order: -1;
            }
        }

        .action-item {
            > .tabs {
                .tab-content {
                    padding: 15px 0;
                    .tab-pane {
                        overflow-y: auto;
                        padding: 15px 30px;
                        height: calc(var(--window-height, 100vh) - (#{$modal-header-height} +
                            #{$modal-footer-height} +
                            #{$tab-nav-height})
                            + #{$tab-sm-adjust}
                        );
                    }
                }
            }
        }

        .modal-body {
            padding: 0;
        }
    }

    @include media-breakpoint-up(md) {
        .action-modal {
            .modal-body {
                padding: map_get($spacers, 3);
            }

            .action-item {
                > .tabs {
                    .tab-content {
                        .tab-pane {
                            height: calc(var(--window-height, 100vh) - (#{$modal-header-height} +
                            #{$modal-footer-height} +
                            #{$modal-body-padding} +
                            #{$tab-nav-height} +
                            #{$tab-content-padding})
                            );
                        }
                    }
                }
            }
        }
    }
</style>
